module.exports = __webpack_public_path__ + "img/profess5.71da69bd.png";